import { render, staticRenderFns } from "./skuSetting.vue?vue&type=template&id=f37638b4&scoped=true&"
import script from "./skuSetting.vue?vue&type=script&lang=js&"
export * from "./skuSetting.vue?vue&type=script&lang=js&"
import style0 from "./skuSetting.vue?vue&type=style&index=0&id=f37638b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37638b4",
  null
  
)

export default component.exports